'use client';

import React from 'react';
import { Slide } from '@/shared/types';
import { ClockIcon } from '@phosphor-icons/react';

// Interfaces and types
interface TimePaneProps {
  slide: Slide;
}

// Component definition
const TimePane: React.FC<TimePaneProps> = ({
  slide
}) => {
  return <div className='slide-boxes mini text-white' data-sentry-component="TimePane" data-sentry-source-file="timePane.tsx">
      <ClockIcon weight="duotone" className='w-4 h-4' data-sentry-element="ClockIcon" data-sentry-source-file="timePane.tsx" />
      <span>{slide.time && slide.isTimeValid !== false ? slide.time : 'Time not specified'}</span>
    </div>;
};
export default TimePane;